import React from 'react';
import { useNavigate } from 'react-router-dom';
import './UpgradeModal.css';

const UpgradeModal = ({ isOpen, onClose, currentTier = 'free' }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const tiers = [
    {
      id: 'paid',
      name: 'Paid',
      icon: '💎',
      price: 2.99,
      features: [
        '3 Personas',
        '6 Sequences per persona',
        '15 Daily predictions',
        'Advanced analytics',
        'Ad-Free Experience',
        'Comprehensive report'
        
      ],
      popular: true
    },
    {
      id: 'premium',
      name: 'Premium',
      icon: '👑',
      price: 6.99,
      features: [
        '5 Personas',
        '8 Sequences per persona',
        '25 Daily predictions',
        'Ad-Free Experience',
        'Early Access Features',
        'Category & localization focus*',
        'Advanced analytics report',
        'Community Abassador',
        'Incorporate validated events',
        
      ],
      popular: false
    }
  ];

  const handleUpgrade = (tier) => {
    // Close modal
    onClose();
    
    // Navigate to payment page with tier data
    navigate('/payment', {
      state: { tier }
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="upgrade-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-modal-btn" onClick={onClose}>
          ✕
        </button>

        <div className="modal-header">
          <h2>Upgrade Your Plan</h2>
          <p>Unlock more features and boost your prediction capabilities</p>
        </div>

        <div className="current-plan-badge">
          <span>Current Plan:</span>
          <span className={`plan-name plan-${currentTier}`}>
            {currentTier === 'free' ? '🆓 Free' : 
             currentTier === 'paid' ? '💎 Paid' : 
             '👑 Premium'}
          </span>
        </div>

        <div className="tiers-grid">
          {tiers.map((tier) => (
            <div
              key={tier.id}
              className={`tier-card ${tier.popular ? 'popular' : ''} ${
                currentTier === tier.id ? 'current' : ''
              }`}
            >
              {tier.popular && (
                <div className="popular-badge">
                  ⭐ Most Popular
                </div>
              )}

              <div className="tier-header">
                <span className="tier-icon">{tier.icon}</span>
                <h3 className="tier-name">{tier.name}</h3>
              </div>

              <div className="tier-price">
                <span className="price-amount">${tier.price}</span>
                <span className="price-period">/month</span>
              </div>

              <ul className="tier-features">
                {tier.features.map((feature, index) => (
                  <li key={index}>
                    <span className="feature-icon">✓</span>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              {currentTier === tier.id ? (
                <button className="tier-btn current-plan" disabled>
                  Current Plan
                </button>
              ) : (
                <button
                  className="tier-btn upgrade-btn"
                  onClick={() => handleUpgrade(tier)}
                >
                  Upgrade to {tier.name}
                </button>
              )}
            </div>
          ))}
        </div>

        <div className="modal-footer">
          <div className="guarantee-badge">
            <span className="badge-icon">🛡️</span>
            <div>
              <strong>30-Day Money-Back Guarantee</strong>
              <p>Cancel anytime. No questions asked.</p>
            </div>
          </div>

          <div className="payment-methods">
            <p>Secure payment with:</p>
            <div className="payment-icons">
              <span>💳</span>
              <span>🍎</span>
              <span>🔒</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;